import { render, staticRenderFns } from "./AssignmentToGroup.vue?vue&type=template&id=62addfe7&scoped=true"
import script from "./AssignmentToGroup.vue?vue&type=script&lang=js"
export * from "./AssignmentToGroup.vue?vue&type=script&lang=js"
import style0 from "./AssignmentToGroup.vue?vue&type=style&index=0&id=62addfe7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62addfe7",
  null
  
)

export default component.exports